module.exports = __webpack_public_path__ + "static/diy_recipe_bio_bird_feeder_thumbnail_alt-9241e0fa9862fdcd1fc4c4f352dfb930.jpg";